import { User } from 'oidc-client-ts';

interface SilentRenewCapable {
  signinSilent: () => Promise<User | null>;
}

let inflight: Promise<User | null> | null = null;

/**
 * Silent renew SINGLE-FLIGHT : tous les appelants concurrents (handler 401,
 * switch de rôle, renew auto…) partagent la même promesse — les logs serveur
 * montraient des rafales de 2-3 émissions de tokens en ~500 ms pour un même
 * utilisateur (renews concurrents). Une seule requête /connect/token à la fois.
 */
export const signinSilentSingleFlight = (
  auth: SilentRenewCapable
): Promise<User | null> => {
  if (!inflight) {
    inflight = auth.signinSilent().finally(() => {
      inflight = null;
    });
  }
  return inflight;
};
